import React, { useState, useContext } from 'react';
import {
  Modal,
  Box,
  Typography,
  Tabs,
  Tab,
  IconButton,
  Avatar,
  TextField,
  Button,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { AuthContext } from '../contexts/AuthContext';
import { logout as apiLogout } from '../api/Authentication/api';

const UserProfileModal = ({ open, onClose, user }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { logout: contextLogout } = useContext(AuthContext);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem('refresh_token');
      await apiLogout(refreshToken);
      contextLogout();
      onClose();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="user-profile-modal"
      aria-describedby="user-profile-details"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Avatar
            sx={{ width: 80, height: 80, margin: '0 auto 1rem' }}
            alt={user?.name}
            src="/avatar.png"
          />
          <Typography variant="h6">{user?.name}</Typography>
          <Typography color="textSecondary">{user?.email}</Typography>
          <Typography color="textSecondary">Role: {user?.role?.name}</Typography>
        </Box>

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#124F3E',
            },
          }}
        >
          <Tab
            icon={<EditIcon />}
            iconPosition="start"
            label="Update Profile"
            sx={{
              '&.Mui-selected': {
                color: '#124F3E',
              },
              minHeight: 48,
              '& .MuiTab-iconWrapper': {
                marginRight: 1,
              },
            }}
          />
          <Tab
            icon={<LogoutIcon />}
            iconPosition="start"
            label="Logout"
            sx={{
              '&.Mui-selected': {
                color: '#124F3E',
              },
              minHeight: 48,
              '& .MuiTab-iconWrapper': {
                marginRight: 1,
              },
            }}
          />
        </Tabs>

        <Box sx={{ mt: 3 }}>
          {activeTab === 0 ? (
            <Box component="form" sx={{ '& > :not(style)': { mb: 2 } }}>
              <TextField
                fullWidth
                label="Name"
                defaultValue={user?.name}
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Email"
                defaultValue={user?.email}
                variant="outlined"
                disabled
              />
              <Button
                fullWidth
                variant="contained"
                startIcon={<EditIcon />}
                sx={{
                  bgcolor: '#124F3E',
                  '&:hover': {
                    bgcolor: '#0D3F32',
                  },
                }}
              >
                Update Profile
              </Button>
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Typography sx={{ mb: 2 }}>
                Are you sure you want to logout?
              </Typography>
              <Button
                variant="contained"
                color="error"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default UserProfileModal;
